"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _default2 = _interopRequireDefault(require("./default"));

exports.default = _default2.default;